import type { SelectChangeEvent } from '@mui/material';
import type { SetStateAction } from 'react';
import { useCallback, useState } from 'react';

export const useSelectValue = <T = string>(
    initialState: T | (() => T)
): [T, (event: SelectChangeEvent<T>) => void, (value: SetStateAction<T>) => void] => {
    const [value, setValue] = useState(initialState);
    const onSelectChange = useCallback((event: SelectChangeEvent<T>) => {
        setValue(event.target.value as T);
    }, []);

    return [value, onSelectChange, setValue];
};
